import type { ReactNode } from "react";
import { ActivityChartDensityButton } from "@components/activityTimeline/ActivityChartDensityButton";
import { ActivityFiltersBar } from "@components/activityTimeline/filters/ActivityFiltersBar";
import type { ActivityChartDensityControl } from "@components/activityTimeline/useActivityChartDensity";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";
import { HistoryFilters } from "@hooks/view/useHistoryPageFiltersCache";
import { useHistoryFilterTabs } from "./historyFilterTabs";

interface HistoryTimelineToolbarProps {
    filters: HistoryFilters;
    onFiltersChange: (filters: Partial<HistoryFilters>) => void;
    search: string | undefined;
    onSearchChange: (search: string | undefined) => void;
    isChannelFilterEnabled: boolean;
    onClearFilters?: () => void;
    chartDensity: ActivityChartDensityControl;
    /** The page's date button, shared with the toolbar the timeline replaces. */
    dateFilter: ReactNode;
}

/** The workspace Activity toolbar with the timeline on. */
export const HistoryTimelineToolbar = ({
    filters,
    onFiltersChange,
    search,
    onSearchChange,
    isChannelFilterEnabled,
    onClearFilters,
    chartDensity,
    dateFilter,
}: HistoryTimelineToolbarProps) => {
    const tabs = useHistoryFilterTabs({
        filters,
        onChange: onFiltersChange,
        isChannelFilterEnabled,
    });
    return (
        <ActivityFiltersBar
            search={search}
            onSearchChange={onSearchChange}
            tabs={tabs}
            onClearFilters={onClearFilters}
        >
            <ActivityChartDensityButton
                density={chartDensity.density}
                hint={chartDensity.hint}
                onDensityChange={chartDensity.setDensity}
            />
            {dateFilter}
            <EntityFilterCombobox
                filters={filters}
                onChange={onFiltersChange}
                showLabel={false}
            />
        </ActivityFiltersBar>
    );
};
